export const GET_APPLICATION_LOCALES_REQUEST =
  'GET_APPLICATION_LOCALES_REQUEST';
export const GET_APPLICATION_LOCALES_SUCCESS =
  'GET_APPLICATION_LOCALES_SUCCESS';
export const GET_APPLICATION_LOCALES_ERROR = 'GET_APPLICATION_LOCALES_ERROR';
export const GET_APPLICATION_INFO_REQUEST = 'GET_APPLICATION_INFO_REQUEST';
export const GET_APPLICATION_INFO_SUCCESS = 'GET_APPLICATION_INFO_SUCCESS';
export const GET_APPLICATION_INFO_ERROR = 'GET_APPLICATION_INFO_ERROR';
export const UPDATE_APPLICATION_INFO_REQUEST =
  'UPDATE_APPLICATION_INFO_REQUEST';
export const UPDATE_APPLICATION_INFO_SUCCESS =
  'UPDATE_APPLICATION_INFO_SUCCESS';
export const UPDATE_APPLICATION_INFO_ERROR = 'UPDATE_APPLICATION_INFO_ERROR';
export const GET_APPLICATION_PROPERTIES_REQUEST =
  'GET_APPLICATION_PROPERTIES_REQUEST';
export const GET_APPLICATION_PROPERTIES_SUCCESS =
  'GET_APPLICATION_PROPERTIES_SUCCESS';
export const GET_APPLICATION_PROPERTIES_ERROR =
  'GET_APPLICATION_PROPERTIES_ERROR';
export const UPDATE_APPLICATION_PROPERTIES_REQUEST =
  'UPDATE_APPLICATION_PROPERTIES_REQUEST';
export const UPDATE_APPLICATION_PROPERTIES_SUCCESS =
  'UPDATE_APPLICATION_PROPERTIES_SUCCESS';
export const UPDATE_APPLICATION_PROPERTIES_ERROR =
  'UPDATE_APPLICATION_PROPERTIES_ERROR';
